<template>
  <v-card 
    class="promo-sheet text-center mx-auto overflow-hidden relative" 
    max-width="400" 
    elevation="12"
  >
    <div class="top-accent"></div>
    <v-btn 
      icon 
      absolute 
      top 
      left 
      @click="$emit('close')" 
      class="close-btn mt-3 ml-3"
    >
      <v-icon color="grey darken-1">mdi-close</v-icon>
    </v-btn>

    <v-card-text class="pa-8 pt-10">
      
      <div class="d-flex justify-center align-center mb-6">
        <span class="brand-text font-weight-black grey--text text--darken-3">{{ brandName }}</span>
        <div class="visual-icon-wrapper mx-2 mb-0">
        <img v-if="logoSrc" :src="logoSrc" alt="Logo" class="object-contain" />
      </div>

      </div>

      <h2 class="title-text font-weight-black mb-1 grey--text text--darken-4">
        یک 
        <span class="primary-highlight-box">{{ qrType }}</span> 
        مثل این برای  خودت بساز!
      </h2>

      <div class="feature-box d-flex align-center justify-center mx-auto mb-8">
        <v-icon color="amber darken-2" size="20" class="ml-2">mdi-flash</v-icon>
        <span class="grey--text text--darken-3 font-weight-bold">سریع و حرفه‌ای</span>
      </div>

      <div v-for="(btn, index) in buttons" :key="index" class="mb-2">
        <v-btn
          block
          height="56"
          :color="btn.color || primaryColor"
          :dark="btn.dark !== false"
          class="action-btn font-weight-bold text-body-1"
          @click="$emit('action', btn.action)"
        >
          <v-icon v-if="btn.icon" size="24" class="ml-2">{{ btn.icon }}</v-icon>
          {{ btn.text }}
        </v-btn>        
        <div v-if="btn.subtext" class="text-caption grey--text mt-2">
          {{ btn.subtext }}
        </div>
      </div>

    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PromoSheet',
  props: {
    qrType: {
      type: String,
      default: 'کیوآر کارت ویزیت'
    },
    logoSrc: {
      type: String,
      default: 'logos/logo_terminalads.webp' 
    },
    brandName: {
      type: String,
      default: 'ترمینال تبلیغات'
    },
    primaryColor:{ 
        type:String,
        default:"#e52d8c"
    },
    buttons: {
      type: Array,
      default: () => [
        {
          text: 'ثبت نام / ورود',
          icon: "mdi-account-arrow-right-outline",
          color: '#2563C5',
          subtext: '',
          action: 'sms'
        },
      ]
    }
  }
}
</script>

<style scoped>
/* استایل کلی پاپ‌آپ */
.promo-sheet {
  border-radius: 32px !important; 
  font-family: inherit; 
  background-color: #ffffff;
  position: relative;
}

/* نوار رنگی تزئینی بالای مودال */
.top-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #2563C5, #64B5F6);
}

/* دکمه بستن با بک‌گراند محو */
.close-btn {
  background-color: #f5f5f5 !important;
  transition: all 0.2s;
}
.close-btn:hover {
  background-color: #e0e0e0 !important;
}

/* استایل آواتار لوگو */
.brand-avatar {
  background-color: #f8f9fa00;
  border: 1px solid #eeeeee00;
  padding: 4px;
}
.brand-text {
  font-size: 0.9rem;
}
.object-contain {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

/* المان بصری مرکزی (دایره آبی محو) */
.visual-icon-wrapper {
  width: 76px;
  height: 76px;
  background: #eef2f900;
  /* border-radius: 50%; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 8px 24px rgba(37, 99, 197, 0.12); */
  border: 2px solid #ffffff00;
}

/* عنوان اصلی */
.title-text {
  font-size: 1.2rem !important;
  line-height: 2 !important; 
  letter-spacing: 0 !important;
}

/* باکس هایلایت برای کلمه کلیدی (مثل کیوآر کارت ویزیت) */
.primary-highlight-box {
  background: #EEF2F9;
  color: #1E63C3;
  padding: 4px 12px;
  border-radius: 12px;
  display: inline-block;
  margin: 0 4px;
  font-size: 1.15rem;
  border: 1px solid rgba(37, 99, 197, 0.1);
}

/* باکس ویژگی (جایگزین خطوط Divider) */
.feature-box {
  background: #FAFAFA;
  border-radius: 16px;
  padding: 10px 16px;
  border: 1px dashed #E0E0E0;
  display: inline-flex;
  transition: all 0.3s;
}
.feature-box:hover {
  background: #F3F4F6;
  border-color: #BDBDBD;
}

/* دکمه اصلی (با سایه مدرن) */
.action-btn {
  letter-spacing: 0 !important;
  text-transform: none !important; 
  border-radius: 18px !important; 
  box-shadow: 0 8px 20px -6px rgba(37, 99, 197, 0.5) !important; /* سایه رنگی جذاب */
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px -6px rgba(37, 99, 197, 0.6) !important;
}
</style>
